import { DownArrowIcon } from 'assets/icons';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useScrollDirection from 'shared/hooks/useScrollDirection';
import { elementVisibility } from 'shared/util/utility';
import { useCacheView } from './CacheView';

const ScrollToTop: React.FC = () => {
	const { scrollDir, scrolledToBottom } = useScrollDirection(0);
	const [showScroll, setShowScroll] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { resetCacheViewByUrl } = useCacheView();

	useEffect(() => {
		const unlisten = history.listen((newLocation, action) => {
			if (action === 'PUSH' || action === 'REPLACE') {
				window.scrollTo(0, 0);
				resetCacheViewByUrl(newLocation, location);
			}
		});
		return () => {
			unlisten();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [history]);

	useEffect(() => {
		const checkScrollTop = () => {
			if (window.pageYOffset > 2200) {
				setShowScroll(true);
			} else if (window.pageYOffset <= 2200) {
				setShowScroll(false);
			}
		};
		window.addEventListener('scroll', checkScrollTop);
		return () => {
			window.removeEventListener('scroll', checkScrollTop);
		};
	}, []);

	const scrollClassName = `${elementVisibility(scrolledToBottom, scrollDir, 'custom-scroll-top')}`;

	const staticClassName = 'custom-scroll-top--lower';

	return (
		<div className={`custom-scroll-top user-select-none ${showScroll ? scrollClassName : staticClassName}`} onClick={scrollTop}>
			<DownArrowIcon />
		</div>
	);
};

const scrollTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default ScrollToTop;
